import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-duty-info-dialog',
  templateUrl: './duty-info-dialog.component.html',
  styleUrls: ['./duty-info-dialog.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DutyInfoDialogComponent {
  constructor(private dialog: MatDialog) {}

  onCloseDialog(): void {
    this.dialog.closeAll();
  }
}
